import { render, staticRenderFns } from "./mercadolibre.vue?vue&type=template&id=64b2b7a3"
import script from "./mercadolibre.vue?vue&type=script&lang=js"
export * from "./mercadolibre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports